var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "home"
  }, [_c('Header'), _c('div', {
    staticClass: "usercont content"
  }, [_c('NavMenu'), _c('div', {
    staticClass: "menucont"
  }, [_c('div', {
    staticClass: "right_top"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("我的发票抬头")]), _c('router-link', {
    staticClass: "add",
    attrs: {
      "to": "/invoiceedit",
      "tag": "div"
    }
  }, [_c('i', {
    staticClass: "iconfont el-icon-plus"
  }), _vm._v("新建发票抬头 ")])], 1), _c('div', [_vm.isNodata ? _c('div', {
    staticClass: "norecord"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/no_record.png")
    }
  }), _c('span', [_vm._v("暂无数据")])]) : _vm._e(), _c('ul', _vm._l(_vm.invoiceList, function (item, index) {
    return _c('li', {
      key: item.id,
      on: {
        "click": function click($event) {
          return _vm.invoiceSelect(item, index);
        }
      }
    }, [_c('div', {
      staticClass: "info"
    }, [_c('div', [_vm._v(_vm._s(item.invoiceName))]), item.email ? _c('div', [_c('span', [_vm._v("接收邮箱：")]), _vm._v(" " + _vm._s(item.email) + " ")]) : _vm._e(), item.telephone ? _c('div', [_c('span', [_vm._v("电话：")]), _vm._v(" " + _vm._s(item.telephone) + " ")]) : _vm._e(), item.invoiceNo ? _c('div', [_c('span', [_vm._v("纳税人识别号：")]), _vm._v(" " + _vm._s(item.invoiceNo) + " ")]) : _vm._e(), item.bank ? _c('div', [_c('span', [_vm._v("开户行：")]), _vm._v(" " + _vm._s(item.bank) + " ")]) : _vm._e(), item.bankNo ? _c('div', [_c('span', [_vm._v("银行账号：")]), _vm._v(" " + _vm._s(item.bankNo) + " ")]) : _vm._e(), item.companyAddress ? _c('div', [_c('span', [_vm._v("注册地址：")]), _vm._v(" " + _vm._s(item.companyAddress) + " ")]) : _vm._e()]), _c('div', {
      staticClass: "btn_box"
    }, [_c('b', [_vm._v(_vm._s(item.invoiceType === 3 ? '增值税电子专票' : '增值税电子普票'))]), _c('i', {
      staticClass: "iconfont iconbianji1",
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.editInvoice(item.id);
        }
      }
    }), _c('i', {
      staticClass: "iconfont iconshanchu",
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.deleteInvoice(item.id);
        }
      }
    })])]);
  }), 0)])])], 1), _c('Footer')], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };